/**
 * Nombre con el que se guarda el PDF de un documento: «Pedido 1062 - <cliente>.pdf».
 *
 * Sin el espacio que llevaba delante, y sin « - undefined» cuando la entidad no trae el nombre del
 * cliente (pasaba con las segmentaciones: «Blender 6 - undefined.pdf»). Un cliente que no llega ni
 * como objeto tampoco puede dejar al usuario sin descarga.
 */
export function nombrePdf(titulo: string, numero: unknown, cliente?: {nombreCompleto?: string} | null): string {
    const nombreCliente = typeof cliente?.nombreCompleto === 'string' ? cliente.nombreCompleto.trim() : '';
    const base = [titulo, numero].filter(parte => parte !== undefined && parte !== null && String(parte).trim() !== '')
        .map(parte => String(parte).trim())
        .join(' ');
    return `${nombreCliente ? `${base} - ${nombreCliente}` : base}.pdf`;
}
